export const OBSERVATION_TOPICS = ["history", "probes", "overview", "exports", "voices"] as const;
export type ObservationTopic = typeof OBSERVATION_TOPICS[number];
export const OBSERVATION_CHANNEL = "nexra_observation";

export type ObservationChange = Readonly<{
  version: 1;
  topic: ObservationTopic;
  userId?: string;
  id?: string;
  requestIds?: readonly string[];
  taskIds?: readonly string[];
  resync?: boolean;
}>;

export function isObservationChange(value: unknown): value is ObservationChange {
  if (!value || typeof value !== "object") return false;
  const change = value as ObservationChange;
  return change.version === 1 && OBSERVATION_TOPICS.includes(change.topic)
    && (change.userId === undefined || typeof change.userId === "string")
    && (change.id === undefined || typeof change.id === "string")
    && (change.resync === undefined || typeof change.resync === "boolean")
    && [change.taskIds, change.requestIds].every(ids => ids === undefined || (Array.isArray(ids) && ids.length <= 100 && ids.every(id => typeof id === "string")));
}
